import React, { useCallback, useEffect, useMemo } from 'react';
import cn from 'classnames';
import throttle from 'lodash/throttle';
import Header from './Header';
import TableRow from './TableRow';
import { getTableRows } from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/helpers';
import { listenerDelay, navCellsCount } from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/constants';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

import standingStyles from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/standingTable.module.scss';
import styles from './rank.module.scss';

const Rank = () => {
  const { state, setRankColumnCount } = useScorecardContext();
  const { data: { categories = [], periods = [] }, columnState } = state;
  const { rankTableIndex: index, rankTableColumnCount: count } = columnState;
  const resizeHandler = useCallback(() => {
    let newCount;

    switch (true) {
      case (document.body.offsetWidth < 670):
        newCount = 0;
        break;
      case (document.body.offsetWidth < 1230):
        newCount = 1;
        break;
      case (document.body.offsetWidth < 1300):
        newCount = 2;
        break;
      case (document.body.offsetWidth < 1500):
        newCount = 3;
        break;
      default:
        newCount = 4;
        break;
    }

    if (count !== newCount) {
      setRankColumnCount(newCount);
    }
  }, [setRankColumnCount, count]);

  useEffect(() => {
    const throttledHandler = throttle(resizeHandler, listenerDelay);

    resizeHandler();
    window.addEventListener('resize', throttledHandler);
    return () => {
      window.removeEventListener('resize', throttledHandler);
    };
  }, [resizeHandler]);

  const rankRows = useMemo(() => getTableRows(categories), [categories]);

  const sliceOfPeriods = useMemo(() => periods.slice(index, count + index), [periods, index, count]);

  if (!count) {
    return null;
  }

  const containerClass = cn(
    standingStyles.leftInnerShadow,
    styles.container,
    {
      [styles.fixContainerSize]: count === 1,
    },
  );

  return (
    <div className={ containerClass } data-test="scorecardTableRank">
      <table className={ standingStyles.dataTable }>
        <Header
          countColumn={ count }
          periods={ sliceOfPeriods }
        />
        <tbody>
          { rankRows.map(({ key, ...row }, rowIndex) => (<TableRow key={ key } { ...row } rowIndex={ rowIndex } />)) }
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={ sliceOfPeriods.length + navCellsCount } />
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default Rank;
